import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Icon, Row, Col, Button, Divider, Dropdown, Menu, message, Modal } from 'antd';
import './style.css';

// Actions
import { save_department, get_department, delete_department, get_department_by_id, edit_department } from './actions/department.action';

// Childe Components
import NewDepartment from './childs/new.department';
import EditDepartment from './childs/edit.department';


const confirm = Modal.confirm;
class Department extends Component {


    constructor( props ){
        super( props )

        this.state = {
            new_department_modal: false,
            edit_department_modal: false,
            department_id: '',
            data: [],
            edit_data: []
        }

        this.handleNewDepartment = this.handleNewDepartment.bind( this );
        this.handleSubmit = this.handleSubmit.bind( this );
        this.handleSubmitEdit = this.handleSubmitEdit.bind( this );
        this.handleController = this.handleController.bind( this );

    }

    handleController( e ){
        let self = this;

        if( e.key === '1' ){
            
            this.props.get_department_by_id( e.item.props.id );

        } else if( e.key === '2' ){
            
            confirm({
                title: 'Do you Want to delete this Department?',
                onOk() {
                    self.props.delete_department( e.item.props.id );
                },
                onCancel() {
                    // Nothing
                },
            });

        }
    }

    handleNewDepartment(){
        this.setState({ new_department_modal: true, edit_department_modal: false })
    }

    handleSubmit( data ){

        this.props.save_department( data );

        this.setState({
            new_department_modal: false
        })

    }

    handleSubmitEdit( data ){

        this.props.edit_department( data );

        this.setState({
            edit_department_modal: false
        })

    }

    componentWillMount(){
        this.props.get_department();
    } 

    componentWillReceiveProps( nextProps ){

        if( nextProps.department.length === 0 ){
            console.log( 'Slow Data Fetching ...' )
            return false;
        }

        // Start

        if( nextProps.department.STATUS.CODE === "200" && 
            nextProps.department.STATUS.MESSAGE === "Successfully Saved Department" ) {
            message.success('Successfully Saved Department');
            this.props.get_department();

            this.setState({
                new_department_modal: false,
                edit_department_modal: false,
            })

        } else if ( nextProps.department.STATUS.CODE === "200" && 
            nextProps.department.STATUS.MESSAGE === "Successfully Listed Department" ) {
            this.setState({
                data: nextProps.department.OUTPUT.DATA,
                new_department_modal: false,
                edit_department_modal: false,
            });

        } else if ( nextProps.department.STATUS.CODE === "200" && 
            nextProps.department.STATUS.MESSAGE === "Successfully Deleted Department" ) {
            message.success('Successfully Deleted Department');
            this.props.get_department();
            
            this.setState({
                new_department_modal: false,
                edit_department_modal: false,
            })

        } else if ( nextProps.department.STATUS.CODE === "200" && 
            nextProps.department.STATUS.MESSAGE === "Successfully Listed By ID" ) {

            this.setState({
                edit_data: nextProps.department.OUTPUT.DATA,
                edit_department_modal: true,
                new_department_modal: false
            });

        } else if ( nextProps.department.STATUS.CODE === "200" && 
            nextProps.department.STATUS.MESSAGE === "Successfully Updated Department" ) {

            message.success('Successfully Updated Department');
            this.props.get_department();
            
            this.setState({
                new_department_modal: false,
                edit_department_modal: false,
            })

        } else if ( nextProps.department.STATUS.CODE === "400" ) {

            message.error( nextProps.department.STATUS.MESSAGE );
            
            this.setState({
                new_department_modal: false,
                edit_department_modal: false,
            })

        }

        // End

    }

    render() {

        const department_list = this.state.data.map( (item, i) => <li key={ i } className="list">
            <Dropdown overlay={ <Menu onClick={ this.handleController }>
                <Menu.Item key="1" id={ item.department_id } ><Icon type="edit" />Edit &nbsp;&nbsp;&nbsp;&nbsp;</Menu.Item>
                <Menu.Item key="2" id={ item.department_id } ><Icon type="delete" />Delete &nbsp;&nbsp;&nbsp;&nbsp;</Menu.Item>
                </Menu> } trigger={['click']}>
                <span className="control"><Icon type="ellipsis" /></span>
            </Dropdown>

            <h3>{ item.department_name }</h3>
            <p>{ item.department_email }</p>
        </li> )

        return (
            <div className="department_wrapper">

                <Row gutter={16}>
                    <Col span={12}>
                        <h2>
                            <Icon type="solution" />
                            &nbsp; Departments
                        </h2>
                    </Col>
                    <Col span={12}>
                        <Button
                            onClick={ this.handleNewDepartment }
                            className="fl_right" type="primary" icon="plus">Add Department</Button>
                    </Col>
                </Row>

                <Divider />

                <Row gutter={16}>
                    <Col span={24}>
                        <ul className="department_list">
                            { department_list }
                        </ul>
                    </Col>
                </Row>

                <NewDepartment onSubmit={ this.handleSubmit } onModel={ this.state.new_department_modal } />
                <EditDepartment onSubmit={ this.handleSubmitEdit } onModel={ this.state.edit_department_modal } data={ this.state.edit_data } />
                
                
            </div>
        )
    }
}

function mapStatetoProps( state ){
    return {
        department: state.department
    }
}

export default connect( mapStatetoProps, { save_department, get_department, delete_department, get_department_by_id, edit_department } )( Department );



// WEBPACK FOOTER //
// ./src/pages/department/index.js